import React from 'react';
import { motion } from 'framer-motion';
export function HowItWorks() {
  const steps = [{
    num: '1',
    text: 'Take CitrusBurn™ daily as directed'
  }, {
    num: '2',
    text: 'The thermogenic blend activates your metabolism'
  }, {
    num: '3',
    text: 'Watch the fat melt away — especially around your belly'
  }];
  return <section className="py-16 lg:py-24 bg-slate-50" data-id="element-53">
      <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8" data-id="element-54">
        <div className="text-center mb-16" data-id="element-55">
          <h2 className="text-3xl sm:text-4xl font-bold text-slate-900" data-id="element-56">
            How CitrusBurn™ Works
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-57">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-1/6 right-1/6 h-0.5 bg-[#E8441A]/20 -z-0" data-id="element-58"></div>

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="relative z-10 flex flex-col items-center text-center" data-id="element-59">
              <div className="w-24 h-24 bg-[#E8441A] text-white rounded-full flex items-center justify-center text-3xl font-bold shadow-xl mb-6 border-4 border-white" data-id="element-60">
                {step.num}
              </div>
              <p className="text-lg sm:text-xl font-medium text-slate-800 max-w-xs" data-id="element-61">
                {step.text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}